module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/e3cb10c34fa4d47f3d18132005111c19.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Epic/Epic5.svg
// module id = w22/
// module chunks = 1